import { PrivateVenueMask, PublicVenueMask } from '@sda/sdk/masks';
import { Reducers } from '@sda/enums/store';
import { SDKFactory } from './helpers/sdk.factory';
import { SDK } from './helpers/sdk';
import type { FetchDataType, FirestoreClientData, Sitemap } from './interfaces';
import type { Invitation } from '@sda/interfaces/invitation';
import type { PublicVenue, PrivateVenue, Venue } from '@sda/interfaces/venue';

/**
 * SDK Class to interact with Firestore Venues.
 */
export class Venues extends SDK<PublicVenue> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.VENUES);

    this.collection = this.fsh.Schema.PublicVenues;

    this.PublicMap = PublicVenueMask;

    this.PrivateMap = PrivateVenueMask;
  }

  async getCombined(id: string): Promise<Venue & FetchDataType> {
    return this.getCombinedRecord<PrivateVenue>(
      id,
      this.Private().collection,
    );
  }

  Private(): typeof ExtendedSDK {
    interface PrivateSDK extends SDK<PrivateVenue> {
      Invitations: (id: string) => SDK<Invitation>;
    }

    let ExtendedSDK = SDKFactory<PrivateVenue>(
      this.fsh.clientData,
      this.fsh.Schema.PrivateVenues,
      { reducerName: Reducers.VENUES },
    ) as PrivateSDK;

    ExtendedSDK.Invitations = (id: string) => SDKFactory<Invitation>(
      this.fsh.clientData,
      this.fsh.getCollection<Invitation>(this.fsh.Schema.PrivateVenues, id, 'Invitations'),
      { reducerName: Reducers.INVITATIONS },
    );

    return ExtendedSDK;
  }

  Sitemap(): SDK<Sitemap> {
    return SDKFactory<Sitemap>(this.fsh.clientData, this.fsh.Schema.Sitemap_Venues);
  }
}
